import React, { useEffect, useMemo, useState } from "react";
import { useMutation } from "@apollo/client";
import { Button, Modal } from "react-bootstrap";
import { useRecoilValue } from "recoil";
import { addToProjectAtom, alankaramDataAtom } from "../../../state";
import { ADD_PROJECT_SUMMARY } from "../graphQl/Mutation";
import validator from 'validator'
import { toast } from "react-toastify";
import { Notification } from "../../../lib/Notification";
import { Spin } from "antd";
import { alankaramConstant } from "../../../constant";
import { getAlankaramConstantByUrl } from "../../../utils/utils"

const SaveProjectModal = ({
    show,
    onHide,
    setUniqueCode,
    setProductSummary
}) => {
    const userDataJSON = localStorage.getItem('userData');
    const userData = userDataJSON ? JSON.parse(userDataJSON) : null;
    const [details, setDetails] = useState({
        name: userData?.name || '',
        email: userData?.email || ''
    })
    const addToProject = useRecoilValue(addToProjectAtom);
    const [validateEmail, setValidateEmail] = useState(true);
    const [addProjectMutation] = useMutation(ADD_PROJECT_SUMMARY)
    const [loading, setLoading] = useState(false)
    const alankaramData = useRecoilValue(alankaramDataAtom);


    const totalPrice = useMemo(() => addToProject.reduce((acc, d) => acc + (d.sumCalculate || 0), 0), [addToProject]);


    useEffect(() => {
        if (details?.email) {
            const checkEmail = validator.isEmail(details?.email)
            setValidateEmail(checkEmail)
        } else {
            setValidateEmail(true)
        }
    }, [details?.email])

    const onSubmit = async () => {
        if (details?.name && details?.email && validateEmail) {
            const newData = addToProject?.map(data => {
                if (data?.type === 'pillow') {
                    const newPart = data?.parts?.map(partData => {
                        const { image, ...rest } = partData
                        return { ...rest }
                    })
                    return { ...data, parts: newPart }
                } else {
                    return data
                }
            })
            const hostName = window.location.host === 'design.suitepieces.com'

            let sortedProductList = [...newData]
            sortedProductList.sort((a, b) => {
                const dateA = new Date(a.createdAt);
                const dateB = new Date(b.createdAt);
                return dateB.getTime() - dateA.getTime();
            });

            const company = getAlankaramConstantByUrl()

            const input = {
                name: details?.name,
                email: details?.email,
                productSummary: sortedProductList,
                environment: hostName,
                customerId: userData?._id,
                totalPrice: totalPrice,
                companyId: alankaramData.companyId ?? "",
                contact: { mobile: company.mobile, email: company.email }
            }
            addProjectMutation({ variables: { input: input } })
                .then(({ data }) => {
                    setUniqueCode(data?.addProductSummary?.uniqueCode)
                    setProductSummary(data?.addProductSummary)
                    onHide();
                    toast.success(Notification['Save project'])
                    setLoading(false)
                }).catch(err => {
                    toast.error(err?.message || err)
                    setLoading(false)
                })


        } else if (!validateEmail) {
            setLoading(false)
            setValidateEmail(false)
        } else {
            setLoading(false)
            toast.warn(Notification['Required file'])
        }
    }

    return (
        <Modal
            show={show}
            onHide={onHide}
            className="save-modal"
        >
            <Modal.Header closeButton> </Modal.Header>
            <Modal.Body className="w-full">
                <div className="text-center mb-[48px]">
                    <h2 className="mb-2 pb-1">Finalize Selection</h2>
                    <h5 className="sub-title mb-5 !text-gray-600">
                        You did it! You're one step closer to the home of your dreams!
                        Provide us the following info to save & view your design.
                    </h5>
                    <form className="text-left">
                        <label className="w-100 mb-3">
                            <span>Name</span>
                            <input type="text" name="name" className="w-100 mt-3" value={details?.name} onChange={e => setDetails({
                                ...details,
                                name: e.target.value
                            })} />
                        </label>

                        <label className="w-100 mb-3">
                            <span className="mb-5">Email</span>
                            <input type="text" name="EMAIL" className={`w-100 mt-3 ${validateEmail ? '' : 'error-email'}`} value={details?.email}
                                onChange={e => setDetails({
                                    ...details,
                                    email: e.target.value
                                })} />
                        </label>
                    </form>
                    <Button
                        className="btn btn-primary mt-3 w-full rounded"
                        onClick={() => {
                            if (!loading) {
                                setLoading(true)
                                onSubmit()
                            }
                        }}
                    >
                        Submit
                        {loading && <Spin className="submit-loader" />}
                    </Button>
                </div>
            </Modal.Body>
        </Modal>
    )
}

export default SaveProjectModal